import * as React from 'react';

function SvgTurnOnOff(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" {...props}>
      <path d="M48 3.9v9.2c8.4 4.3 14.1 13.1 14.1 23.2 0 14.5-11.7 26.2-26.1 26.2-14.4 0-26.1-11.7-26.1-26.2 0-9.3 4.8-17.4 12.1-22.1V4.7C9.9 10.1 1.4 22.2 1.4 36.3 1.4 55.5 16.9 71 36 71s34.6-15.5 34.6-34.7c0-14.9-9.4-27.5-22.6-32.4z" />
      <path d="M35 34.6c2.8 0 5-1.8 5-4V4.4c0-2.2-2.2-4-5-4s-5 1.8-5 4v26.2c0 2.2 2.2 4 5 4z" />
    </svg>
  );
}

export default SvgTurnOnOff;
